import { endOfYesterday, format } from 'date-fns/esm';
import { Text } from '@simplywallst/ui-core';

export const LastUpdated = () => {
  const yesterday = format(endOfYesterday(), 'MMM dd, yyyy');
  return (
    <Text typography="tiny" color="white">
      <Text as="span" color="whiteRGBA" opacity={0.7}>
        UPDATED
      </Text>{' '}
      {yesterday}
    </Text>
  );
};
